import Link from 'next/link'
import { cx } from 'class-variance-authority'
import { QuestionIcon } from '@phosphor-icons/react/dist/ssr/Question'

type DocLinkProps = {
  component?: string
  className?: string
}

export const DocLink = ({ component = '', className }: DocLinkProps) => (
  <Link
    href="https://support.skop.app/fr"
    target="_blank"
    className={cx(
      'rounded-full p-1',
      {
        'block text-border hover:bg-slate-800 sm:hidden':
          component === 'navbar',
        'hidden text-slate-500 hover:text-slate-300 sm:block':
          component !== 'navbar',
        '!p-0': component === 'menu',
      },
      className,
    )}
  >
    <span className={cx({ 'sr-only': component !== 'menu' })}>Support</span>
    {component !== 'menu' && (
      <QuestionIcon className="size-6" aria-hidden="true" />
    )}
  </Link>
)
